<template>
  <div style="padding: 30px;">
    <!-- 搜索条件 -->
    <el-form :inline="true" class="search-form">
      <el-form-item label="商户订单号">
        <el-input v-model="filters.out_trade_no" placeholder="请输入商户订单号" />
      </el-form-item>
      <el-form-item label="平台订单号">
        <el-input v-model="filters.trade_no" placeholder="请输入平台订单号" />
      </el-form-item>
      <el-form-item label="广告主ID">
        <el-input v-model="filters.account_id" placeholder="请输入广告主ID" />
      </el-form-item>
      <el-form-item label="广告ID">
        <el-input v-model="filters.adgroup_id" placeholder="请输入广告ID" />
      </el-form-item>
      <el-form-item label="回传状态">
        <el-select v-model="filters.is_callback" placeholder="请选择">
          <el-option label="全部" :value="0" />
          <el-option label="未回传" :value="1" />
          <el-option label="已回传" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 订单列表表格 -->
    <el-table v-loading="loading" :data="orders" border style="width: 100%">
      <el-table-column align="center" prop="out_trade_no" label="商户订单号" width="250" />
      <el-table-column align="center" prop="trade_no" label="平台订单号" width="250" />
      <el-table-column align="center" prop="created_at" label="创建时间" width="200" />
      <el-table-column align="center" prop="pay_amount" label="支付金额(分)" width="100">
        <template #default="scope">
          {{ scope.row.pay_amount }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="pay_time" label="支付时间" width="200" />
      <el-table-column align="center" prop="is_callback" label="回传状态" width="140">
        <template #default="scope">
          <span>
            {{ scope.row.is_callback === 1 ? '未回传' : scope.row.is_callback === 2 ? '已回传' : '全部' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="account_id"
        label="回传广告主"
        width="130"
      />
      <el-table-column
        align="center"
        prop="adgroup_id"
        label="广告ID"
        width="130"
      />
      <el-table-column align="center" prop="is_callback" label="操作">
        <template #default="scope">
          <span v-if="scope.row.is_callback == 1">
            <el-button type="primary" size="mini" @click="huichuan(scope.row)">回传</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      ref="paginationbox"
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import { adqorderlist, adqmanualback } from '@/api/notify.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      orders: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      filters: {
        out_trade_no: '',
        trade_no: '',
        is_callback: 0,
        account_id: '',
        adgroup_id: ''
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      adqorderlist({
        page: this.page,
        page_size: this.pageSize,
        ...this.filters
      }).then(res => {
        // 假设返回结构 { data: { list: [], total: 100 } }
        this.orders = res.data.list || []
        this.total = res.data.total || 0
      })
        .finally(() => {
          this.loading = false
        })
    },
    resetFilters() {
      this.filters = {
        out_trade_no: '',
        trade_no: '',
        is_callback: 0,
        account_id: '',
        adgroup_id: ''
      }
      this.page = 1
      this.fetchData()
    },
    handlePageChange(newPage) {
      this.page = newPage
      this.fetchData()
    },
    // 分页
    fetchPageSizer(e) {
      this.pageSize = e
      this.page = 1
      this.fetchData()
    },
    fetchCurrentPager(e) {
      this.page = e
      this.fetchData()
    },
    huichuan(item) {
      adqmanualback({
        id: item.id
      }).then((res) => {
        this.$message({
          message: '回传成功',
          type: 'success'
        })
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}
</style>
